import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { apiurl } from '../../../../../path'
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext'
const WorkOrderList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllWorkOrderList } = context
    const [workorder, setWorkOrderList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
    const [selectedVendor, setSelectedVendor] = useState('');
    const [selectedPaidAmount, setSelectedPaidAmount] = useState('');
    const getWorkOrderList = async () => {
        let data = await GetAllWorkOrderList();
        console.log("data", data);
        setWorkOrderList(data);
        setFilteredBills(data);
    };

    useEffect(() => {
        getWorkOrderList()
    }, [])
    let workorderList = []
    if (workorder.length > 0) {
        workorderList = workorder
    }

    // useEffect(() => {
    //     let filtered = workorder;
    //     if (selectedVendor) {
    //         filtered = filtered.filter(order => order.ContractorName === selectedVendor);
    //     }
    //     if (selectedPaidAmount) {
    //         filtered = filtered.filter(order => order.PaidAmount === parseFloat(selectedPaidAmount));
    //     }
    //     filtered = filtered.filter(bill =>
    //         Object.values(bill).some((val) =>
    //             (val || '').toString().toLowerCase().includes(searchTerm.toLowerCase())
    //         )
    //     );

    //     setFilteredBills(filtered);
    //     setCurrentPage(1);
    // }, [searchTerm, selectedVendor, selectedPaidAmount, workorder]);
    const vendorNames = [...new Set(workorder.map(order => order.ContractorName))];
    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = workorder.filter(bill =>
            Object.values(bill).some(val =>
                (val || '').toString().toLowerCase().includes(term)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, workorder]);

    const paidAmounts = selectedVendor
        ? [...new Set(workorder.filter(order => order.ContractorName === selectedVendor).map(order => order.PaidAmount))].sort((a, b) => a - b)
        : [...new Set(workorder.map(order => order.PaidAmount))].sort((a, b) => a - b);


    // return (

    //     <>
    //         <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">
    //                 <div className="col-12">

    //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                         {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
    //                         <h5 className='my-auto fw-bold'>
    //                             <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                             <span className='my-auto'>Work Order List</span>
    //                         </h5>
    //                         {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
    //                         value={searchTerm}
    //                         style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search Here"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>
    //                     </div>


    //                     <div className="col-12 pb-5">
    //                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
    //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
    //                                             <th style={{ minWidth: "70px", padding: "8px" }}>Sr.no.</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>Vendor Name</th>
    //                                             <th style={{ minWidth: "200px", padding: "8px" }}>Work Name</th>
    //                                             <th style={{ minWidth: "120px", padding: "8px" }}>Work Order No</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>Work Order Date</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>Work End Date</th>
    //                                             <th style={{ minWidth: "180px", padding: "8px" }}>Approved Work Amount</th>
    //                                             <th style={{ minWidth: "130px", padding: "8px" }}>Paid Amount</th>
    //                                             <th style={{ minWidth: "150px", padding: "8px" }}>Remaining Amount</th>
    //                                             <th style={{ minWidth: "260px", padding: "8px" }}>Copy of Work Order</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>Creation Date</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {currentBills?.length === 0 ? (
    //                                             <tr>
    //                                                 <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                     No data available
    //                                                 </td>
    //                                             </tr>
    //                                         ) : (
    //                                             currentBills?.map((workorder, index) => {
    //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                 return (
    //                                                     <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }}>
    //                                                         <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.ContractorName}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.WorkName}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.WorkOrderNo}</td>
    //                                                         <td style={{ padding: '8px' }}>{new Date(workorder.WorkOrderDate).toLocaleString()}</td>
    //                                                         <td style={{ padding: '8px' }}>{new Date(workorder.WorkEndDate).toLocaleString()}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.ApprovedWorkAmount}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
    //                                                         <td style={{ padding: '8px' }}>{workorder.RemainingAmount}</td>
    //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`} target='_blank'>{workorder.CopyofWorkOrder}</a></td>
    //                                                         <td style={{ padding: '8px' }}>{new Date(workorder.Date).toLocaleString()}</td>
    //                                                     </tr>
    //                                                 );
    //                                             })
    //                                         )}
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             <div className="col-12 mt-4">
    //                                 <div className='row'>
    //                                     <div className='col-6'>
    //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
    //                                             Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, filteredBills.length)} of {workorder.length} entries
    //                                         </p>
    //                                     </div>

    //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
    //                                         {/* First Page Button */}
    //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                             &laquo;
    //                                         </button>
    //                                         {/* Previous Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage - 1)}
    //                                             disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &lt;
    //                                         </button>

    //                                         <button
    //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                         </button>
    //                                         {/* Next Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage + 1)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &gt;
    //                                         </button>
    //                                         {/* Last Page Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(totalPages)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &raquo;
    //                                         </button>
    //                                     </div>

    //                                 </div>
    //                             </div>

    //                         </div>


    //                     </div>
    //                 </div>


    //             </div>

    //         </div>
    //     </>
    // )
    return (

        <>
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("Work Order List")}</span>
                            </h5>
                            {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>


                        <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                                <th style={{ minWidth: "70px", padding: "8px" }}>{t("Sr.no.")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Vendor Name")}</th>
                                                <th style={{ minWidth: "200px", padding: "8px" }}>{t("Work Name")}</th>
                                                <th style={{ minWidth: "120px", padding: "8px" }}>{t("Work Order No")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Work Order Date")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Work End Date")}</th>
                                                <th style={{ minWidth: "180px", padding: "8px" }}>{t("Approved Work Amount")}</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>{t("Paid Amount")}</th>
                                                <th style={{ minWidth: "150px", padding: "8px" }}>{t("Remaining Amount")}</th>
                                                <th style={{ minWidth: "260px", padding: "8px" }}>{t("Copy of Work Order")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Creation Date")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentBills?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                currentBills?.map((workorder, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }}>
                                                            <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.ContractorName}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.WorkName}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.WorkOrderNo}</td>
                                                            <td style={{ padding: '8px' }}>{new Date(workorder.WorkOrderDate).toLocaleString()}</td>
                                                            <td style={{ padding: '8px' }}>{new Date(workorder.WorkEndDate).toLocaleString()}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.ApprovedWorkAmount}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.PaidAmount}</td>
                                                            <td style={{ padding: '8px' }}>{workorder.RemainingAmount}</td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`} target='_blank'>{workorder.CopyofWorkOrder}</a></td>
                                                            <td style={{ padding: '8px' }}>{new Date(workorder.Date).toLocaleString()}</td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-12 mt-4">
                                    <div className='row'>
                                        <div className='col-6'>
                                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                                {t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {workorder.length} {t("entries")}
                                            </p>
                                        </div>

                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            {/* First Page Button */}
                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                &laquo;
                                            </button>
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &lt;
                                            </button>

                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                            </button>
                                            {/* Next Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &gt;
                                            </button>
                                            {/* Last Page Button */}
                                            <button
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &raquo;
                                            </button>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>


                </div>

            </div>
        </>
    )
}

export default WorkOrderList
